<template>
    <div class="fb-group-feed" style="max-width: 600px; margin: 0 auto; padding: 10px;">
        <h2 v-if="group">
            <a :href="'https://facebook.com/' + gid" class="fb-post-name" target="_blank">
                {{ group.name }}
            </a>
        </h2>
        <p v-if="group" style="font-size: 13px; text-align: left">
            {{ group.description }}
        </p>
        <img v-if="group && group.cover" :src="group.cover.source" style="width: 100%"/>

        <div v-if="posts">
            <div v-for="post in posts">
                <hr style="border-top: 1px dashed #8c8b8b; border-bottom: 1px dashed #fff;"/>
                <fb-post type="post" :post="post"/>
                <div v-if="post.comments" style="margin-left: 30px; margin-top: 10px; margin-bottom: 10px;">
                    <div v-for="comment in post.comments.data">
                        <fb-post type="comment" :post="comment"/>
                        <div v-if="comment.comments" style="margin-left: 30px; margin-top: 10px; margin-bottom: 10px;">
                            <div v-for="sub_comment in comment.comments.data">
                                <fb-post type="comment" :post="sub_comment"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
        </div>

    </div>
</template>

<script>
    import axios from 'axios';
    import infiniteScroll from 'vue-infinite-scroll'
    import FBHelper from '@/libs/fb-helper';
    import FBMongo from '@/libs/fb-mongo';

    export default {
        data: () => ({
            gid: '',
            uid: undefined,
            posts: [],
            group: undefined,
            user_stats_map: {},
            next_page: undefined,
            errors: undefined,
        }),
        directives: {infiniteScroll},
        components: {
            'fb-post': () => import('../post')
        },
        created() {
            document.title = 'Group: '
            this.gid = this.$route.params.gid

            if (this.$route.query.token) {
                localStorage.token = this.$route.query.token
            }
            if (this.$route.query.uid) {
                this.uid = this.$route.query.uid
            }

            if (!localStorage.token) throw "token missing"
            if (!this.gid) throw "gid missing"

            this.loadFeed()
        },
        methods: {
            async loadFeed() {
                this.next_page = undefined

                FBHelper.getGroupInfo(this.gid).then(group => {
                    document.title = 'Group: ' + group.name
                    this.group = group
                })

                var [posts, user_stats_map] = await Promise.all([
                    this.getPosts({gid: this.gid, uid: this.uid, limit: 10}),
                    FBMongo.getAllUserStatsMap(this.gid)
                ])

                this.fillUserStats(user_stats_map, posts)
                this.user_stats_map = user_stats_map
                this.posts = posts
            },

            async loadMore() {
                if (this.next_page === undefined) {
                    return
                }
                var posts = await this.getPosts({url: this.next_page})
                this.fillUserStats(this.user_stats_map, posts)
                this.posts.push(...posts)
            },

            async getPosts(params) {
                var response = await FBMongo.getPosts(params)

                var posts = response.data
                this.next_page = response.next_page

                await this.fillInfoUsers(posts)
                return posts
            },

            async fillInfoUsers(posts) {
                var froms = FBHelper.expandFroms(posts)
                var uids = Object.keys(_.groupBy(froms, 'id'))

                const usersMap = await FBHelper.getInfoUsersMap(uids)
                froms.forEach(from => _.assign(from, usersMap[from.id]))
            },

            fillUserStats(user_stats_map, posts) {
                FBHelper.expandFroms(posts).forEach(from => _.assign(from, user_stats_map[from.id]))
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    fb-group-feed {
        max-width: 600px;
        margin: 0 auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/fb/group/feed.vue